import React from 'react';

import ShowOnly from '@fundera/fundera-design-system/components/ShowOnly';
import {
  HeaderComponent,
  SecondaryNav,
  useSecondaryNav,
  constants,
} from '@fundera/fundera-design-system';

import navigationLinks from './navigationLinks';

const headerButton = {
  text: (
    <ShowOnly minBreakpoint="5" fallback="Get Started">
      See Your Loan Options
    </ShowOnly>
  ),
  url: 'https://www.fundera.com/apply',
};

const mobileButton = {
  text: 'See Your Loan Options',
  url: headerButton.url,
};

const PageHeaderTemplate = () => {
  const { links, active } = useSecondaryNav();
  return (
    <HeaderComponent
      logoImage={constants.logos.Fundera}
      logoURL="/"
      mobileButton={mobileButton}
      headerButton={headerButton}
      headerLinks={[
        {
          path: '/how-it-works',
          text: 'How It Works',
          minBreakpoint: 'header-how-works',
        },
        { path: '/login', text: 'Login' },
      ]}
      navigationLinks={navigationLinks}
      secondaryNav={active ? <SecondaryNav links={links} /> : null}
      hideSubmenu={active}
      fullWidth
    />
  );
};

export default PageHeaderTemplate;
